/**
 * PHONE LINKS DIAL AS +1 (2026-10-27, Layne, Teams: "converting tel: links to +1 at build time
 * works for us, so no block change. Please go ahead.")
 *
 * Division phone numbers reach the blocks dashed ("904-555-1234"), and the `tel:` link carried
 * the same dashed form. Phones dial a +1 number reliably from any client; a dashed one depends on
 * the client. So when the email is filed, every US `tel:` link is rewritten to `tel:+1` + the ten
 * digits. Only the link changes: the number people read stays exactly as written.
 *
 * Only a real `href` attribute is touched (not `data-href` / `xlink:href`). Left alone: a number
 * that already starts with `+` (it is already international), anything with a `{{token}}` or
 * `%%AMPscript%%` in it (it is filled later), anything holding a letter or `;` `,` `#` `*` (an
 * extension or a pause: "x22", "ext", ";ext=") and anything that is not ten digits, or eleven
 * starting with 1, once ( ) . - and spaces are dropped. Running it twice gives the same result.
 * The backend applies the same rule when it writes the Content Builder asset, so a proofing
 * revision cannot put a dashed link back.
 */
export function telLinksPlusOne(html: string): string {
  if (!html || html.toLowerCase().indexOf("tel:") < 0) return html;
  return html.replace(/(^|[\s"'])(href\s*=\s*)(["'])\s*tel:([^"']*)\3/gi, (m, lead: string, pre: string, q: string, num: string) => {
    const raw = String(num || "").trim();
    if (!raw || raw.charAt(0) === "+" || /[^\d\s().-]/.test(raw)) return m;
    const d = raw.replace(/\D/g, "");
    const ten = d.length === 10 ? d : d.length === 11 && d.charAt(0) === "1" ? d.slice(1) : "";
    if (!ten) return m;
    return lead + pre + q + "tel:+1" + ten + q;
  });
}
